import { MIN_PASS_LENGTH } from 'shared/utils/forms'

/* eslint-disable quotes */
export const errorStatusMessage = {
  defaultMessage: 'Something went wrong',
  tryAgain: 'Try Again',
  already_exists: 'User with provided username already exists',
  permission_denied: 'You have no permissions',
  not_authenticated: 'You are not authorized',
  transaction_limit: 'Transfer is out of limits',
  transaction_limit_does_not_exist: 'Limits for transactions does not exist',
  400: 'Bad request',
  invalid_date: 'Invalid date',
  mustBeAtLeast18YearsOld: 'Must be at least 18 years old',
  passwordsDoNotMatch: 'Passwords do not match',
  emailsDoNotMatch: 'Emails do not match',
  minPassLength: `Should contain at least ${MIN_PASS_LENGTH} characters`,
  invalidUserNameOrPassword: 'Incorrect username or password',
  referral_code_not_found: 'Referral code not found',
  referral_code_already_activated: 'Referral code already activated',
  fieldMustBeMoreThan: 'The field must be more than X characters',
  referral_site_name_blank: 'This field may not be blank',
  referral_site_link_blank: 'This field may not be blank',
  referral_site_link_invalid: 'Enter a valid URL',
  not_enough_money: 'Not enough money',
  email_not_verified: 'Please confirm your email',
  documents_not_approved: 'Please confirm your documents',
  balance_not_low_enough: 'Real balance too high for exchanging',
  sipsak_error: 'Invalid security key',
  coefs_changed: 'Coefs were changed.',
  error_block_bet_data: 'Some rate is blocked now',
  error_exist_bet: 'Some rate does not exist',
  user_is_banned: 'This account is banned',
  payment_system_limits: 'The amount does not meet the limits',
  incorrect_old_password: 'Incorrect old password',

  illegalAge: 'You must be at least 18 years old to register',
  futureDate: 'Choosen date may not be ahead of the present',

  required: 'Required',
  enterValidEmail: 'Enter valid email',
  yearsMustBeOver: 'Should be at least 18 years old',
  enterValidPhone: 'Enter valid phone number',

  passwords_match_error: 'The new password must be different from the current one.',
  user_with_username_already_exists: 'User with username already exists',
  bonus_is_already_accrued: 'Bonus is already accrued to player',
  user_not_found: 'User not found',
  not_enough_balance: 'Not enough balance',
  document_already_exist: 'Document already exist',
  access_and_refresh_token_invalid: 'Your session has expired. Please log in again',
  payment_system_limit_attempts_exceeded: 'The withdrawal request limit has been exceeded.',
  player_withdraw_blocked: 'Withdrawals are limited for you. Please contact support',
  user_is_frozen: 'You have been frozen.',
  spin_insufficient_funds: 'Spin min balance $min_amount',
  payout_kyc_restricted: 'Payment is limited because the user has not submitted documents for verification.',
  transaction_error: 'Operation failed! Please try again or contact our support team',
  payment_system_money_amount_exceeded: 'Payment system money amount exceeded',
  payment_system_disabled: 'Something went wrong, contact support',
  insufficient_funds_on_bonus_balance: "Bonus balance's too low for transfer",
  amountMustBeMoreThan: 'Amount must be more than min',
  amountMustBeLessThan: 'Amount must be less than max',
  something_went_wrong: 'Something went wrong. Please, contact technical support',
}
